// extracted by mini-css-extract-plugin
export default {"alumni-email":"email_alumni-email__1GSOE","password":"email_password__O0K8m","input":"email_input__cJv+h","show-password":"email_show-password__TQTTt","spacer":"email_spacer__cZNrm"};